<template>
  <div class="register-view">
    <div class="register-container">
      <img src="@/assets/mdg-image.png" class="mdg-image" />
      <el-form
        v-if="mode === 'register'" :model="registerForm" ref="registerForm"
        :rules="registerFormRules" class="register-form"
        @validate="onRegisterFormValidate"
      >
        <h1>注册</h1>
        <h2>欢迎来到{{ title }}管理系统</h2>
        <el-form-item prop="name" class="form-item">
          <el-input
            v-model.trim="registerForm.name" clearable placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="mobilePhone" class="form-item">
          <el-input
            v-model.trim="registerForm.mobilePhone" clearable placeholder="请输入手机号码"
          ></el-input>
          <span v-if="registerForm.mobilePhoneAvailable" class="el-form-item__error available-tip">
            该手机号码可用于注册
          </span>
          <span slot="error" slot-scope="{error}" class="el-form-item__error">
            <span>{{ error }}</span>
            <template v-if="error === '该手机号码已绑定其他微信号'">
              <span class="text-danger">，</span>
              <span @click="navigateToLogin" class="login-link">
                <span>去登录</span>
                <i class="mdg-icon ico_arrow_right_grayx"></i>
              </span>
            </template>
          </span>
        </el-form-item>
        <el-form-item prop="password" class="form-item">
          <el-input
            v-model="registerForm.password" show-password
            clearable placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item prop="verificationCode" class="form-item">
          <el-input
            v-model.trim="registerForm.verificationCode"
            placeholder="请输入4位短信验证码" class="sms-code-input"
          >
            <el-button
              slot="suffix" @click="sendVerificationCode"  type="text"
              :loading="registerForm.queryCodeLoading" class="sms-code-btn"
              :disabled="
                registerForm.timeCount !== 0 || !/^[1][3-9][0-9]{9}$/.test(registerForm.mobilePhone)
              "
            >
              <span v-if="registerForm.queryCodeLoading">发送中</span>
              <span v-else-if="registerForm.timeCount === 0">
                {{ registerForm.queryCodeFirstTime ? '获取短信验证码' : '重发短信验证码' }}
              </span>
              <span v-else>{{ registerForm.timeCount }} 秒</span>
            </el-button>
          </el-input>
        </el-form-item>
        <el-button
          @click="submitRegisterForm" type="primary"
          :disabled="!validateRegisterForm()" class="width-100"
        >
          提交
        </el-button>
        <el-row type="flex" justify="space-between" align="middle" class="mt-20">
          <el-col :span="18">
            <el-form-item prop="agreementChecked" class="form-item checkbox-form-item mb-0">
              <el-checkbox v-model="registerForm.agreementChecked" class="text-xxs">
                <span class="text-xxs">同意</span>
                <router-link
                  :to="{ name: 'registration-agreement' }"
                  target="_blank" class="link text-xxs"
                ><!--
                -->《<template v-if="!identifierEnabled">墨点狗</template>用户注册协议》
                </router-link>
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="text-right login-hint">
            <span>已有账号？</span>
            <router-link :to="{ name: 'login-view' }" class="link">
              登录
            </router-link>
          </el-col>
        </el-row>
      </el-form>
      <div v-if="mode === 'project'" class="project-form">
        <div @click="skipCreateProject" class="skip-tip">
          <span>跳过</span>
          <i class="mdg-icon ico_arrow_right_grayx"></i>
        </div>
        <el-form
          :model="projectForm" ref="projectForm"
          :rules="projectFormRules"
        >
          <h1>创建项目</h1>
          <el-form-item prop="name" class="form-item mt-55">
            <el-input v-model.trim="projectForm.name" clearable placeholder="请输入项目名称"></el-input>
          </el-form-item>
          <el-form-item prop="unitName" class="form-item">
            <el-input
              v-model.trim="projectForm.unitName" clearable placeholder="请输入单位名称"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item prop="type" class="form-item">
            <el-select v-model="projectForm.type" placeholder="请选择管理类型" class="width-100">
              <el-option
                v-for="item in projectTypes" :key="item.id"
                :label="item.name" :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item prop="category" class="form-item">
            <el-select v-model="projectForm.category" placeholder="请选择所属行业" class="width-100">
              <el-option
                v-for="item in projectCategories" :key="item.id"
                :label="item.name" :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item prop="nature" class="form-item">
            <el-select v-model="projectForm.nature" placeholder="请选择单位性质" class="width-100">
              <el-option
                v-for="item in projectNatures" :key="item.id"
                :label="item.name" :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="identifierEnabled" prop="identifier" class="form-item">
            <el-input
              v-model.trim="projectForm.identifier" clearable placeholder="请输入标识码"
            ></el-input>
          </el-form-item>
          <el-button @click="submitProjectForm" type="primary" class="width-100 mt-30">
            确定
          </el-button>
        </el-form>
      </div>
      <div v-if="mode === 'finished'" class="finished-form">
        <div class="text-center">
          <i class="mdg-icon ico_team_succeedx"></i>
          <div class="finished-hint">
            <template v-if="finishedType === 'created'">项目创建成功</template>
            <template v-else>注册成功</template>
          </div>
          <div @click="navigateToHome" class="countdown-link">
            开始管理项目（{{ finishedCount }}s）
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import {
  Form, FormItem, Input,
  Select, Option, Button, Checkbox,
} from 'element-ui'
import * as API from '@/api/auth'
import {
  // findProjectCategories,
  findProjectNatures,
  create as createProject,
} from '@/api/project'
import {
  MAIN_CONTROL_URL, SET_USER_INFO,
  PERSONAL_CENTER_URL,
} from '@/utils/constants'

export default {
  name: 'register-view',
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElButton: Button,
    ElCheckbox: Checkbox,
  },
  data() {
    return {
      title: '智慧现场',
      mode: 'register',
      finishedType: 'joined',
      projectName: '',
      registerFormValid: false,
      registerForm: {
        unionId: '',
        name: '',
        password: '',
        mobilePhone: '',
        verificationCode: '',
        agreementChecked: false,
        timeCount: 0,
        queryCodeFirstTime: true,
        queryCodeLoading: false,
        mobilePhoneAvailable: false,
      },
      registerFormRules: {
        name: [{ required: true, message: '请输入姓名' }],
        password: [
          { required: true, message: '请输入密码' },
          { min: 6, message: '密码长度至少为6位' },
          { pattern: /^[A-Za-z0-9_]+$/, message: '密码只能包含数字、字母或下划线' },
        ],
        mobilePhone: [
          { required: true, message: '请输入11位手机号码' },
          { pattern: /^[1][3-9][0-9]{9}$/, message: '请输入11位手机号码' },
          {
            validator: async (rule, value, callback) => {
              const flag = await API.loginAvailable({
                login: value,
              })
              if (flag === true) {
                callback()
              } else if (flag === false) {
                callback(new Error('该手机号已绑定其他微信号'))
              } else {
                callback(new Error('手机号码检查失败'))
              }
            },
          },
        ],
        verificationCode: [
          { required: true, message: '请输入4位短信验证码' },
          { pattern: /^[0-9]{4}$/, message: '请输入4位短信验证码' },
        ],
        agreementChecked: [{
          validator: (rule, value, callback) => {
            if (value) {
              callback()
            } else {
              callback(new Error('必须同意协议才能继续'))
            }
          },
        }],
      },
      projectForm: {
        name: '',
        unitName: '',
        // type: null,
        // category: null,
        nature: null,
        identifier: '',
      },
      projectFormRules: {
        name: [{ required: true, message: '请输入项目名称' }],
        unitName: [{ required: true, message: '请输入单位名称' }],
        // type: [{
        //   validator: (rule, value, callback) => {
        //     if (_.isNumber(value)) {
        //       callback()
        //     } else {
        //       callback(new Error('请选择组织类型'))
        //     }
        //   },
        // }],
        // category: [{
        //   validator: (rule, value, callback) => {
        //     if (_.isNumber(value)) {
        //       callback()
        //     } else {
        //       callback(new Error('请选择所属行业'))
        //     }
        //   },
        // }],
        nature: [{
          validator: (rule, value, callback) => {
            if (_.isNumber(value)) {
              callback()
            } else {
              callback(new Error('请选择单位性质'))
            }
          },
        }],
        identifier: [{ required: true, message: '请输入标识码' }],
      },
      // projectTypes: [{
      //   id: 0,
      //   name: '项目',
      // }, {
      //   id: 1,
      //   name: '企业',
      // }],
      // projectCategories: [],
      projectNatures: [],
      finishedCount: 3,
    }
  },
  computed: {
    identifierEnabled() {
      return window.VITEC.ENV === 'xianchang'
    },
  },
  async mounted() {
    this.mode = this.$route.query.mode || 'register'
    this.title = window.sessionStorage.getItem('mdg-auth-title') || '智慧现场'
    if (this.mode === 'register') {
      if (this.$route.query.register) {
        this.registerForm.unionId = this.$route.query.register
      } else {
        this.$message({
          type: 'error',
          message: '缺少微信登录参数',
        })
        this.mode = 'unknown'
      }
      this.$refs.registerForm.clearValidate()
    } else if (this.mode === 'project') {
      await this.initProjectOptions()
      this.$refs.projectForm.clearValidate()
    } else if (this.mode === 'finished') {
      this.finishedType = this.$route.query.type || 'joined'
      await this.setUserInfo()
      this.startFinishedCountdown()
    }
  },
  methods: {
    onRegisterFormValidate(prop, valid) {
      if (prop === 'mobilePhone') {
        this.registerForm.mobilePhoneAvailable = valid
      }
    },
    navigateToLogin() {
      this.$router.push({
        name: 'login-view',
      })
    },
    validateRegisterForm() {
      const params = this.registerForm
      if (_.isEmpty(params.name)) {
        return false
      }
      if (!(/^[1][3-9][0-9]{9}$/.test(params.mobilePhone))) {
        return false
      }
      if (params.password.length < 6) {
        return false
      }
      if (!(/^[0-9]{4}$/.test(params.verificationCode))) {
        return false
      }
      if (!params.agreementChecked) {
        return false
      }
      return true
    },
    async initProjectOptions() {
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
      })
      // this.projectCategories = await findProjectCategories()
      this.projectNatures = await findProjectNatures()
      loading.close()
    },
    async sendVerificationCode() {
      this.registerForm.queryCodeLoading = true
      const flag = await API.sendVerificationCode({
        mobilePhone: this.registerForm.mobilePhone,
      })
      this.registerForm.queryCodeLoading = false
      if (flag) {
        this.registerForm.timeCount = 60
        this.registerForm.queryCodeFirstTime = false
        const interval = setInterval(() => {
          this.registerForm.timeCount -= 1
          if (this.registerForm.timeCount === 0) {
            clearInterval(interval)
          }
        }, 1000)
      }
    },
    submitRegisterForm() {
      this.$refs.registerForm.validate(async (valid) => {
        if (valid) {
          try {
            await this.$confirm('确定要提交注册信息吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
            const params = _.pick(this.registerForm, [
              'unionId', 'name', 'password',
              'mobilePhone', 'verificationCode',
            ])
            const loading = this.$loading({
              lock: true,
              text: '加载中...',
            })
            const count = await API.register(params)
            loading.close()
            if (!_.isNumber(count) || count < 0) {
              // 注册失败
              return
            }
            if (count === 0) {
              this.mode = 'project'
              await this.initProjectOptions()
              this.$router.replace({
                name: 'register-view',
                query: {
                  mode: 'project',
                },
              })
            } else if (count > 0) {
              await this.setUserInfo()
              this.mode = 'finished'
              this.finishedType = 'joined'
              this.$router.replace({
                name: 'register-view',
                query: {
                  mode: 'finished',
                  type: 'joined',
                },
              })
              this.startFinishedCountdown()
            }
          } catch (e) {
            // noop
          }
        }
      })
    },
    async skipCreateProject() {
      await this.setUserInfo()
      this.mode = 'finished'
      this.finishedType = 'joined'
      this.$router.replace({
        name: 'register-view',
        query: {
          mode: 'finished',
          type: 'joined',
        },
      })
      this.startFinishedCountdown()
    },
    submitProjectForm() {
      this.$refs.projectForm.validate(async (valid) => {
        if (valid) {
          try {
            await this.$confirm('确定要提交项目信息吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
            const loading = this.$loading({
              lock: true,
              text: '加载中...',
            })
            const flag = await createProject({
              ...this.projectForm,
              setBelong: true,
            })
            loading.close()
            if (flag) {
              await this.setUserInfo()
              this.mode = 'finished'
              this.finishedType = 'created'
              this.$router.replace({
                name: 'register-view',
                query: {
                  mode: 'finished',
                  type: 'created',
                },
              })
              this.startFinishedCountdown()
            }
          } catch (e) {
            // noop
          }
        }
      })
    },
    async setUserInfo() {
      const userInfo = await API.getUserInfo()
      this.projectName = userInfo.projectName
      this.$store.commit(SET_USER_INFO, userInfo)
    },
    startFinishedCountdown() {
      this.finishedCount = 3
      const interval = setInterval(() => {
        this.finishedCount -= 1
        if (this.finishedCount <= 0) {
          clearInterval(interval)
          this.navigateToHome()
        }
      }, 1000)
    },
    navigateToHome() {
      const projectCount = this.$store.state.userInfo.project.length || 0
      if (projectCount > 0) {
        window.location.href = MAIN_CONTROL_URL
      } else {
        window.location.href = PERSONAL_CENTER_URL
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variable.scss';

.register-view {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: calc(50vh - 310px) 0;
  background: #f8f9fa;
}
.register-container {
  display: flex;
  align-items: center;
  margin: 0 auto;
  width: 1076px;
  height: 620px;
  border-radius:8px;
  background: #fff;
  box-shadow: 0px 60px 140px -60px rgba(53,129,251,0.4);
  overflow: hidden;
}
.mdg-image {
  width: 460px;
  height: 620px;
  background: linear-gradient(296deg,rgba(106,131,255,1) 0%,rgba(53,129,251,1) 100%);
}
.register-form, .project-form {
  width: 352px;
  margin: 0 auto;
  h1 {
    margin: 16px 0;
    color: $primary;
    font-size: 24px;
    line-height: 33px;
    font-weight: bold;
  }
  h2 {
    margin: 0 0 40px;
    color: #6f83a1;
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
  }
  .form-item {
    margin-bottom: 32px;
  }
  .link {
    color: $primary;
    line-height: 17px;
    cursor: pointer;
    text-decoration: none;
    &:hover {
      color: darken($primary, 15%);

    }
  }
  .login-hint {
    font-size: 12px;
    color: #a3b4cc ;
    line-height: 17px ;
  }
  .sms-code-btn {
    color: $primary;
    &:hover {
      color: #0E59C7;
    }
    &:active {
      color: darken($primary, 10%);
    }
  }
}
.project-form {
  position: relative;
  box-sizing: border-box;
  margin: 0;
  padding: 104px 132px 0;
  height: 100%;
  width: 616px;
  .skip-tip {
    display: flex;
    align-items: center;
    position: absolute;
    top: 30px;
    right: 30px;
    color: $primary;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    &:hover {
      color: #0E59C7;
    }
    &:active {
      color: darken($primary, 10%);
    }
    i.mdg-icon {
      font-size: 24px;
    }
  }
}
.finished-form {
  width: 352px;
  margin: 0 auto;
  i.mdg-icon {
    font-size: 72px;
    color: $primary;
  }
  .finished-hint {
    margin: 15px 0 6px;
    font-size: 24px;
    line-height: 33px;
    color: #131D2D;
    font-weight: bold;
  }
  .countdown-link {
    font-size: 18px;
    line-height: 25px;
    color: $primary;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: #0E59C7;
    }
    &:active {
      color: darken($primary, 10%);
    }
  }
}
.login-link {
  color: $primary;
  cursor: pointer;
  text-decoration: underline;
  i.mdg-icon {
    font-size: 12px;
  }
}
.available-tip {
  color: $success !important;
}
</style>
